import AppPageBackground from "./AppPageBackground";

import "./AppPageBackground.scss";

export { AppPageBackground };
